import { gql } from '@apollo/client';

const GET_CLIENT_LEDGER_ACCOUNTS = gql`
  query getLedgerAccounts($clientId: ID!) {
    ledgerAccounts(clientId: $clientId) {
      id
      code
      name
      role
    }
  }
`;

const GET_CLIENT_MONTHLY_DATA = gql`
  query getClientMonthlyData($clientId: ID!) {
    client(id: $clientId) {
      id
      more {
        monthlyData {
          month
          categorizeStatus
        }
      }
    }
  }
`;

const GET_CLIENT_INBOX_STATE = gql`
  query getClientInboxState($clientId: ID!) {
    client(id: $clientId) {
      id
      inboxState
    }
  }
`;

const FEATURE_FLAG_IS_ENABLED = gql`
  query getFeatureEnabled($clientId: ID!, $feature: String!) {
    featureEnabled(id: $clientId, name: $feature)
  }
`;

export const GET_CURRENT_USER = gql`
  query getUser {
    currentUser {
      id
      accessibleClientIds
      roles
    }
  }
`;

export const GET_CLIENT = gql`
  query getClient($clientId: String!) {
    client(clientId: $clientId) @rest(type: "Client", path: "client.json/:clientId") {
      id
      more {
        isB4AClient
      }
    }
  }
`;

export {
  FEATURE_FLAG_IS_ENABLED,
  GET_CLIENT_LEDGER_ACCOUNTS,
  GET_CLIENT_MONTHLY_DATA,
  GET_CLIENT_INBOX_STATE,
};
